import React, { useEffect, useContext } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { HeaderProvider } from '../contexts/HeaderContext';
import { AuthContext, AuthConsumer } from '../lib/contexts/AuthContext';

const PrinterFriendlyLayout  = (props) => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (!authContext.isAuthenticated()) {
      navigate('/login')
    }
  }, [authContext, navigate])

  return (
    <AuthConsumer>
      {context => (
        <HeaderProvider>
          <div className="container">
            <div className="container-main">
                {props.children}
            </div>
          </div>
        </HeaderProvider>
      )}
    </AuthConsumer>
  );
}

export const PrinterFriendlyLayoutRoute = ({ component: Component, ...rest }) => { 
  return (
    <Routes>
      <Route { ...rest} element = {
        <PrinterFriendlyLayout>
          <Component />
        </PrinterFriendlyLayout>
      }/>
    </Routes>
  )
}